/*
 * For more information on the `parentViewport`, please refer to the following:
 * app/assets/javascripts/integration/components/viewport.coffee
 *
 */

import Flux from 'lib/flux';
import IntegrationConstants from 'constants/integration';
import I from 'immutable';

export default Flux.createStore({
  name: 'integration',

  getInitialState() {
    return {
      parentViewport: null,
      parentDetected: false,
    };
  },

  actions: [
    [
      IntegrationConstants.UPDATE_PARENT_VIEWPORT,
      function (parentViewportInfo) {
        Object.keys(parentViewportInfo).forEach((key) => {
          if (/^[-.0-9]*$/.test(parentViewportInfo[key])) {
            parentViewportInfo[key] = parseInt(parentViewportInfo[key], 10);
          }
        });

        // XXX: This is a quickfix. Tech debt ticket filed here: https://github.com/anyroadcom/anyroad/issues/858
        if (!this.state.get('parentViewport')) {
          this.state = this.state.set('parentViewport', I.Map({}));
        }

        this.state = this.state.setIn(['parentDetected'], true);
        this.state = this.state.mergeIn(['parentViewport'], parentViewportInfo);
      },
    ],
  ],
});
